<!-- TODO add right icon depending on integration -->
<h1 mat-dialog-title class="text-center mb-0 fw-bold">Choose your integration</h1>

<mat-divider></mat-divider>

<mat-dialog-content class="mt-1">
        <div class="container-fluid">
            <div class="row">
                <div class="col-4 mb-3" *ngFor="let integration of integrations">
                    <div class="mat-elevation-z2 p-3 d-flex flex-column align-items-center rounded">
                        <mat-icon style="width: 80%;" [svgIcon]="integration.icon"></mat-icon>
                        <button type="button" class="mt-4" mat-raised-button (click)="integration.callBack()"
                            color="primary">select</button>
                    </div>
                </div>
            </div>
        </div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions class="d-flex justify-content-center mt-1">
    <button mat-raised-button mat-dialog-close class="w-25" color="warn">Close</button>
</mat-dialog-actions>